import { authAxios } from "@/api";
import axios from "axios";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "ward";

export class AppointmentApi {
  static getAppointmentDetail(wardId, appointmentId) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.get(url);
  }

  static updateAppointmentDetail(wardId, appointmentId, appointmentInfo){
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.put(url, appointmentInfo);
  }

  static createAppointment(wardId, appointmentInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment`;
    return authAxios.post(url, appointmentInfo);
  }

  static deleteAppointment(wardId, appointmentId) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}`;
    return authAxios.delete(url);
  }

  static searchAppointments(wardId, filterInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointments`;
    return authAxios.post(url, filterInfo);
  }

  static searchAppointmentEvents(wardId, appointmentId, filterInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/appointment/${appointmentId}/events`;
    return authAxios.post(url, filterInfo);
  }

  static getPublicAppointmentSettings(wardId, securityKey) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/settings/${securityKey}`;
    return axios.get(url);
  }

  static createPublicAppointment(wardId, securityKey, appointmentInfo) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/${securityKey}`;
    return axios.post(url, appointmentInfo);
  }

  static lookupContactByPhone(wardId, securityKey, phoneNumber) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/lookup/${securityKey}`;
    return axios.get(url, {
      params: { phone_number: phoneNumber }
    });
  }

  static checkAppointmentAvailability(wardId, securityKey, appointmentDate, appointmentType) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/check-availability/${securityKey}`;
    return axios.post(url, null, {
      params: { 
        appointment_date: appointmentDate,
        appointment_type: appointmentType
      }
    });
  }

  static getAvailableSlotsForDate(wardId, securityKey, appointmentDate, appointmentType) {
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/public/appointment/available-slots/${securityKey}`;
    return axios.get(url, {
      params: { 
        appointment_date: appointmentDate,
        appointment_type: appointmentType
      }
    });
  }
}
